module.exports = __webpack_public_path__ + "static/undraw_creative_team_r90h-b1a9b45562ef5b2ed98dad44a15d1f3f.svg";